/**
 * Created by MTI on 04/05/2018.
 */

import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthResource} from './service/auth.resource';
import {LoginModel} from './service/login.model';
import {AuthServerProvider} from '../common.module/auth/auth-jwt.service';
import {Router} from '@angular/router';
import {ToastService} from 'ng-uikit-pro-standard';
import {LoginService} from './service/login.service';
import {ConfiguracionGeneralModel} from '../admin.configuracion-general.module/service/configuracion-general.model';
import {ConfiguracionGeneralService} from '../admin.configuracion-general.module/service/configuracion-general.service';
import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';
import { concatMap, mergeMap, tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-main-login',
  templateUrl: 'main-login.component.html'
})
export class MainLoginComponent implements OnInit {
  public loginForm: FormGroup;
  public authModel: LoginModel = <LoginModel>{};
  networkMode = 'online';
  public configuracion: ConfiguracionGeneralModel = {};


  constructor(private fb: FormBuilder,
              private loginService: LoginService,
              private authResource: AuthResource,
              private toastMsg: ToastService,
              private http: HttpClient,
              private authProvider: AuthServerProvider,
              private configuracionGeneralService: ConfiguracionGeneralService,
              private router: Router) {
    navigator.onLine === true ? this.networkMode = 'online' : this.networkMode = 'offline';
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ['', Validators.compose([Validators.email, Validators.required])],
      password: ['', [Validators.required]]
    });
    this.configuracionGeneralService.obtenerConfiguracionGeneral().then(configuracion => {
      this.configuracion = configuracion;
    }, err => {
      console.log('Error al cargar la configuración en el pie de página');
      console.error(err);
    });
  }

  

  //CODIGO PARA REALIZAR LA DESCARGA DE DOCUMENTOS DE TRAMITES TIAS
  descargar() {
    const meses = [
      { month: 'junio', year: '2024' },
      { month: 'octubre', year: '2024' },
      { month: 'octubre', year: '2022' },
      { month: 'octubre', year: '2020' },
      { month: 'diciembre', year: '2020' },
      { month: 'junio', year: '2021' },
      { month: 'octubre', year: '2021' },
    ];

    const concurrencia = 2; // configurable: 1 = secuencial, 2 o más = paralelo

    this.descargarZips(meses, concurrencia).subscribe({
      complete: () => console.log('todas las descargas completadas')
    });
  }

  descargarZips(meses: { month: string, year: string }[], concurrencia: number) {
    const baseUrl = 'http://localhost:8006/na/documentos/tias'; // ms-flujos
    const token = '12345678';
    return from(meses).pipe(
      mergeMap(({ month, year }) => {
        const url = `${baseUrl}?month=${month}&year=${year}&token=${token}&readOnly=false`;
        console.log(`gescargando ZIP de ${month} ${year}...`);

        return this.http.get(url, { responseType: 'blob' }).pipe(
          tap(blob => {
            const fileName = `documentos_${month}_${year}.zip`;
            saveAs(blob, fileName);
            console.log(`guardado en ${fileName}`);
          })
        );
      }, concurrencia)
    );
  }

  login() {
    this.authResource.login(<LoginModel> this.loginForm.value).then(res => {
      console.log(res);
      this.authProvider.storeAuthenticationToken(res.token, false);
      this.toastMsg.success('Hemos iniciado sesión.');
      this.router.navigate(['app']);
      // Reditrect app
      // Save token locastorage
    }, err => {
      // Mensaje de error
      console.log(err);
      if (err && err.body && err.body.message)
        this.toastMsg.error(err.body.message);
    });
  }
}
